'use strict';
const _ = require('lodash');
const workerUtils = require('./workerUtils');
const events = require('../events');
const errors = require('../errors');

function getControllersData(configs) {
  return Object.keys(configs).map(function(controllerId) {
    const type = configs[controllerId].controllerData.controllerType;
    const config = configs[controllerId].controllerData.settings;
    const connections = configs[controllerId].connections || [];
    return {
      type,
      config,
      connections,
      $w: self.wix.getSelector(controllerId)
    };
  });
}

function registerControllerEvents(wix, controllerId, configs) { //TODO: Add context
  configs[controllerId].controllerBehaviors.forEach(function(item) {
    var fn = wix.__INTERNAL__.getEventHandler(item.behavior.params.callbackId);
    if (fn) {
      wix.emitter.on(controllerId, item.action.name, fn);
    }
  });
}

function getControllersReadyResolver(app) {
  var controllersReady;
  app.controllersReady = new Promise(resolve => {
    controllersReady = resolve;
  });
  return controllersReady;
}

function callAppCreateControllers(app, configs, reportError) {
  const controllerIds = Object.keys(configs);
  if (!controllerIds.length) {
    return Promise.resolve([]);
  }
  var controllers = [];
  try {
    controllers = app.module.createControllers(getControllersData(configs));
  } catch (err) {
    reportError()(err);
  }
  var wrappedControllers = controllers.map(function(controller, index) {
    var p = Promise.resolve(controller);
    p.catch(reportError(controllerIds[index]));
    return p;
  });
  return Promise.all(wrappedControllers);
}

function getControllersOnReady(controllers, wix, controllerConfigs, app, workerId) {
  const controllerIds = Object.keys(controllerConfigs);
  app.controllers = controllerIds.reduce(function(acc, controllerId, index) {
    var compId = controllerConfigs[controllerId].compId;
    acc[compId] = controllers[index];
    return acc;
  }, {});
  controllerIds.forEach(controllerId => registerControllerEvents(wix, controllerId, controllerConfigs));
  return controllers.map((controller, index) => {
    var controllerId = controllerIds[index];
    var $w = wix.getSelector(controllerId);
    var scopedGlobalSdkApis = wix.getScopedGlobalApis(controllerId);
    return {
      controllerId,
      dependencies: controllerConfigs[controllerId].dependencies || [],
      onReady: $w.onReady.bind($w, function() {
        if (controller.pageReady) {
          return Promise
            .resolve(controller.pageReady($w, scopedGlobalSdkApis))
            .then(warmupData => ({controllerId, warmupData}))
            .catch(function(err) {
              workerUtils.reportBI(errors.PAGE_READY, {
                app_id: app.id,
                worker_id: workerId,
                controller_id: controllerId,
                controller_type: controllerConfigs[controllerId].controllerData.controllerType,
                error: err && err.message
              });
            });
        }
        console.warn('controller.start is deprecated please export controller.pageReady method instead'); // eslint-disable-line no-console
        return controller.start($w);
      })
    };
  });
}

function callControllersReadyInOrder(controllersOnReady) {
  function visit(node) {
    if (node.entered || node.visited) {
      return;
    }
    node.entered = true;
    node.dependencies.forEach(controllerId => {
      const dep = _.find(controllersOnReady, {controllerId});
      if (dep) {
        visit(dep);
      }
    });
    node.visited = true;
    node.onReady();
  }
  let nextNode = _.find(controllersOnReady, node => !node.visited);
  while (nextNode) {
    visit(nextNode);
    nextNode = _.find(controllersOnReady, node => !node.visited);
  }
}


function handleInit({apps}, {workerId, getApp}) {
  if (!apps) {
    throw new Error('Init message data must include apps property');
  }
  const controllersOnReady = [];
  return Promise.all(Object.keys(apps)
    .map(appId => {
      const app = getApp(appId);
      if (!app) {
        console.error(`App with the id - ${appId} failed to load`);// eslint-disable-line no-console
        return Promise.resolve();
      }
      const {controllers: controllerConfigs = {}} = apps[appId];
      var controllersReady = getControllersReadyResolver(app);
      let beforeInit;
      return app.ready
        .then(() => {
          beforeInit = Date.now();
          const reportError = controllerId => err => {
            const params = {
              app_id: appId,
              worker_id: workerId,
              error: err && err.message,
              time_spent: Date.now() - beforeInit
            };
            if (controllerId) {
              params.controller_id = controllerId;
            }
            workerUtils.reportBI(errors.CREATE_CONTROLLERS, params);
          };
          return callAppCreateControllers(app, controllerConfigs, reportError);
        })
        .then(function(controllers) {
          var afterInit = Date.now();
          workerUtils.reportBI(events.CREATE_CONTROLLERS, {
            app_id: appId,
            worker_id: workerId,
            time_spent: afterInit - beforeInit
          });
          controllersReady();
          controllersOnReady.push(...getControllersOnReady(controllers, self.wix, controllerConfigs, app, workerId));
        })
        .catch(controllersReady);
    }))
    .then(() => callControllersReadyInOrder(controllersOnReady));
}

module.exports = {
  handleInit: handleInit
};



// WEBPACK FOOTER //
// ./src/main/worker/initHandler.js